import { jsx } from 'react/jsx-runtime';
import { useState } from 'react';
import { Colors } from '../../../theme/Colors.es.js';
import '../../../theme/Shadows.es.js';
import '../../../theme/Typography.es.js';
import { uniqueId } from '../../../utils/uniqueId.es.js';

const root = "_root_19o5x_1";
const input = "_input_19o5x_8";
const styles = {
	root: root,
	input: input
};

const colorVariations = {
  gray: {
    base: {
      borderColor: Colors.GrayWarm7
    },
    check: {
      borderColor: Colors.Blue3
    },
    hover: {
      borderColor: Colors.Blue3
    },
    focus: {
      backgroundColor: Colors.Blue3,
      borderColor: Colors.Blue3
    }
  },
  white: {
    base: {
      borderColor: Colors.PrimeWhite
    },
    check: {
      borderColor: Colors.PrimeWhite
    },
    hover: {
      borderColor: Colors.PrimeWhite
    },
    focus: {
      backgroundColor: Colors.PrimeWhite,
      borderColor: Colors.PrimeWhite
    }
  }
};
const Indicator = ({ "aria-label": ariaLabel, color, count, noun = "page", onChangeIndex, selectedIndex }) => {
  const [name] = useState(uniqueId("Indicator-"));
  const handleOnChange = ({ target }) => {
    const { value } = target;
    const index = parseInt(value, 10);
    onChangeIndex(index);
  };
  return jsx("div", { "aria-label": ariaLabel, className: styles.root, "data-zds": true, role: "radiogroup", style: {
    "--_zds-indicator-grid-template-columns": `repeat(${count}, 10px)`
  }, children: Array.from({ length: count }, (_, i) => jsx("input", { "aria-label": `${noun} ${i + 1}`, checked: i === selectedIndex, className: styles.input, name, onChange: handleOnChange, style: {
    "--_zds-indicator-before-border-color": colorVariations[color].focus.backgroundColor,
    "--_zds-indicator-border-color": colorVariations[color].base.borderColor,
    "--_zds-indicator-border-color-checked": colorVariations[color].check.borderColor,
    "--_zds-indicator-border-color-focus": colorVariations[color].focus.borderColor,
    "--_zds-indicator-border-color-hover": colorVariations[color].hover.borderColor
  }, type: "radio", value: i, "data-zds": true }, `bubble-${i}`)) });
};

export { Indicator };
//# sourceMappingURL=Indicator.es.js.map
